// extracted by mini-css-extract-plugin
module.exports = {"dot":"styles_dot__v7_1I","sm":"styles_sm__Q5DK_","md":"styles_md__6RXQz","input":"styles_input__z2Hx3"};